import { AbstractControl, ValidationErrors } from '@angular/forms';

export function noSpacesNoSpecialCharacters(
  control: AbstractControl
): ValidationErrors | null {
  const usernameRegex = /^[a-zA-Z0-9]+$/;
  return !control.value || usernameRegex.test(control.value)
    ? null
    : { noSpacesNoSpecial: true };
}
